import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";
import { Revision } from "../../../Models/Revision";
import { Order } from "../../../Models/Order";

export class RevisionAPIHandler {
  public static shared = new RevisionAPIHandler();

  apiHandler = BaseAPICallsHandler.shared;
  serverConfig = ServerConfig.shared;
  networkUtils = NetworkUtils.shared;

  constructor();
  constructor(
    apiHandler: BaseAPICallsHandler,
    serverConfig: ServerConfig,
    networkUtils: NetworkUtils
  );
  public constructor(...params: any[]) {
    if (params.length >= 3) {
      this.apiHandler = params[0];
      this.serverConfig = params[1];
      this.networkUtils = params[2];
    }
  }

  public async askForRevision(revisionData: any, orderId: string): Promise<{revision: Revision, order: Order, paymentInstance?: any}> {
    const url = this.serverConfig.revisionAPIs.askForRevisionAPI(orderId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePostRequest(authHeaders, url, revisionData);
      const revision = new Revision(response.data.revision);
      const order = new Order(response.data.order);
      const paymentInstance = response.data.paymentInstance;

      return Promise.resolve({revision, order, paymentInstance});
    } catch (err) {
      return Promise.reject(err);
    }
  }

    public async verifyPlacedRevision(revisionId: string, razorpayOrderId: string, paymentId: string, signature: string): Promise<{revision: Revision, order: Order, paymentSuccess: boolean}> {
    const url = this.serverConfig.revisionAPIs.verifyPlacedRevisionAPI(revisionId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePostRequest(authHeaders, url, {
        orderId: razorpayOrderId, paymentId, signature
      });
      const revision = new Revision(response.data.revision);
      const order = new Order(response.data.order);
      const paymentSuccess = response.data.paymentSuccess;

      return Promise.resolve({revision, order, paymentSuccess});
    } catch (err) {
      return Promise.reject(err);
    }
  }
  
  public async getRevisionsByOrderId(orderId: string): Promise<Revision[]> {
    const url = this.serverConfig.revisionAPIs.getRevisionsByOrderId(orderId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const revisions = response.data.map((item: any) => new Revision(item));
      return Promise.resolve(revisions);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getRevisionsByDeliveryId(deliveryId: string): Promise<Revision[]> {
    const url = this.serverConfig.revisionAPIs.getRevisionsByDeliveryId(deliveryId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const revisions = response.data.map((item: any) => new Revision(item));
      return Promise.resolve(revisions);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getRevisionsByChannelId(channelId: string): Promise<Revision[]> {
    const url = this.serverConfig.revisionAPIs.getRevisionsByChannelId(channelId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const revisions = response.data.map((item: any) => new Revision(item));
      return Promise.resolve(revisions);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getRevisionById(revisionId: string): Promise<Revision> {
    const url = this.serverConfig.revisionAPIs.getRevisionById(revisionId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      return Promise.resolve(new Revision(response.data.revision));
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async updateRevisionById(revisionId: string, updatedData: any): Promise<Revision> {
    const url = this.serverConfig.revisionAPIs.updateRevisionById(revisionId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePutRequest(authHeaders, url, updatedData);
      return Promise.resolve(new Revision(response.data));
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async deleteRevisionById(revisionId: string): Promise<boolean> {
    const url = this.serverConfig.revisionAPIs.deleteRevisionById(revisionId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      await this.apiHandler.makeDeleteRequest(authHeaders, url, {});
      return Promise.resolve(true);
    } catch (err) {
      return Promise.reject(err);
    }
  }
}
